import { reactive } from 'vue'

const state = reactive({
  visible: false,
  message: '',
  color: 'error',
  timeout: 4000
})

let hideTimer = null

function normalizeMessage(message) {
  return String(message || '').trim()
}

export function getSnackbarState() {
  return state
}

export function hideAppSnackbar() {
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
  state.visible = false
}

export function showAppSnackbar(message, options = {}) {
  const text = normalizeMessage(message)
  if (!text) return

  const { color = 'error', timeout = 4000 } = options

  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }

  state.message = text
  state.color = color
  state.timeout = timeout
  state.visible = true

  if (timeout > 0) {
    hideTimer = setTimeout(() => {
      state.visible = false
      hideTimer = null
    }, timeout)
  }
}

export function showAppError(message, timeout = 5000) {
  showAppSnackbar(message, { color: 'error', timeout })
}

export function showAppSuccess(message, timeout = 4000) {
  showAppSnackbar(message, { color: 'success', timeout })
}

export function showAppWarning(message, timeout = 4500) {
  showAppSnackbar(message, { color: 'warning', timeout })
}

export function showAppInfo(message, timeout = 4000) {
  showAppSnackbar(message, { color: 'info', timeout })
}
